export enum OutgoingInvoiceStatuses {
  PENDING = 1,
  GENERATING = 2,
  SENDING = 3,
  SENT = 4,
  FAILED = 5,
  /** A credit invoice the user chose not to mail; generated and finished. */
  NOT_SENT = 6
}
